'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var HlsjsIPFSLoader = /*#__PURE__*/function () {
  function HlsjsIPFSLoader(config) {
    _classCallCheck(this, HlsjsIPFSLoader);

    this._abortFlag = [false];
    this.ipfs = config.ipfs;
    this.hash = config.ipfsHash;

    if (config.debug === false) {
      this.debug = function () {};
    } else if (config.debug === true) {
      this.debug = console.log;
    } else {
      this.debug = config.debug;
    }

    if (config.m3u8provider) {
      this.m3u8provider = config.m3u8provider;
    } else {
      this.m3u8provider = null;
    }

    if (config.tsListProvider) {
      this.tsListProvider = config.tsListProvider;
    } else {
      this.tsListProvider = null;
    }
  }

  _createClass(HlsjsIPFSLoader, [{
    key: "destroy",
    value: function destroy() {}
  }, {
    key: "abort",
    value: function abort() {
      this._abortFlag[0] = true;
    }
  }, {
    key: "load",
    value: function load(context, config, callbacks) {
      this.context = context;
      this.config = config;
      this.callbacks = callbacks;
      this.stats = {
        trequest: performance.now(),
        retry: 0
      };
      this.retryDelay = config.retryDelay;
      this.loadInternal();
    }
    /**
     * Call this by getting the HLSIPFSLoader instance from hls.js hls.coreComponents[0].loaders.manifest.setM3U8Provider()
     * @param {function} provider
     */

  }, {
    key: "setM3U8Provider",
    value: function setM3U8Provider(provider) {
      this.m3u8provider = provider;
    }
    /**
     *
     * @param {function} provider
     */

  }, {
    key: "setTsListProvider",
    value: function setTsListProvider(provider) {
      this.tsListProvider = provider;
    }
  }, {
    key: "loadInternal",
    value: function loadInternal() {
      var stats = this.stats,
          context = this.context,
          callbacks = this.callbacks;
      stats.tfirst = Math.max(performance.now(), stats.trequest);
      stats.loaded = 0; //When using absolute path (https://example.com/index.html) vs https://example.com/

      var urlParts = window.location.href.split("/");

      if (urlParts[urlParts.length - 1] !== "") {
        urlParts[urlParts.length - 1] = "";
      }

      var filename = context.url.replace(urlParts.join("/"), "");
      var options = {};

      if (Number.isFinite(context.rangeStart)) {
        options.offset = context.rangeStart;

        if (Number.isFinite(context.rangeEnd)) {
          options.length = context.rangeEnd - context.rangeStart;
        }
      }

      if (filename.split(".")[1] === "m3u8" && this.m3u8provider !== null) {
        var res = this.m3u8provider();
        var data;

        if (Buffer.isBuffer(res)) {
          data = buf2str(res);
        } else {
          data = res;
        }

        var response = {
          url: context.url,
          data: data
        };
        callbacks.onSuccess(response, stats, context);
        return;
      }

      if (filename.split(".")[1] === "m3u8" && this.tsListProvider !== null) {
        var tslist = this.tsListProvider();
        var hash = tslist[filename];

        if (hash) {
          this.cat(hash).then(function (res) {
            var data;

            if (Buffer.isBuffer(res)) {
              data = buf2str(res);
            } else {
              data = res;
            }

            stats.loaded = stats.total = data.length;
            stats.tload = Math.max(stats.tfirst, performance.now());
            var response = {
              url: context.url,
              data: data
            };
            callbacks.onSuccess(response, stats, context);
          });
        }

        return;
      }

      this._abortFlag[0] = false;
      getFile(this.ipfs, this.hash, filename, options, this.debug, this._abortFlag).then(function (res) {
        var data = context.responseType === 'arraybuffer' ? res : buf2str(res);
        stats.loaded = stats.total = data.length;
        stats.tload = Math.max(stats.tfirst, performance.now());
        var response = {
          url: context.url,
          data: data
        };
        callbacks.onSuccess(response, stats, context);
      }, console.error);
    }
  }]);

  return HlsjsIPFSLoader;
}();

function getFile(_x, _x2, _x3, _x4, _x5, _x6) {
  return _getFile.apply(this, arguments);
}

function _getFile() {
  _getFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ipfs, rootHash, filename, options, debug, abortFlag) {
    var path;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            debug("Fetching hash for '".concat(rootHash, "/").concat(filename, "'"));
            path = "".concat(rootHash, "/").concat(filename);
            _context.prev = 2;
            _context.next = 5;
            return cat(path, options, ipfs, debug, abortFlag);

          case 5:
            return _context.abrupt("return", _context.sent);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            throw new Error("File not found: ".concat(rootHash, "/").concat(filename));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8]]);
  }));
  return _getFile.apply(this, arguments);
}

function buf2str(buf) {
  return new TextDecoder().decode(buf);
}

function cat(_x7, _x8, _x9, _x10, _x11) {
  return _cat.apply(this, arguments);
}

function _cat() {
  _cat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cid, options, ipfs, debug, abortFlag) {
    var parts, length, offset, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, buf, value, _i, _parts, _buf;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            parts = [];
            length = 0, offset = 0;
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 4;
            _iterator = _asyncIterator(ipfs.cat(cid, options));

          case 6:
            _context2.next = 8;
            return _iterator.next();

          case 8:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 18;
              break;
            }

            buf = _step.value;
            parts.push(buf);
            length += buf.length;

            if (!abortFlag[0]) {
              _context2.next = 15;
              break;
            }

            debug('Cancel reading from ipfs');
            return _context2.abrupt("break", 18);

          case 15:
            _iteratorAbruptCompletion = false;
            _context2.next = 6;
            break;

          case 18:
            _context2.next = 24;
            break;

          case 20:
            _context2.prev = 20;
            _context2.t0 = _context2["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 24:
            _context2.prev = 24;
            _context2.prev = 25;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context2.next = 29;
              break;
            }

            _context2.next = 29;
            return _iterator.return();

          case 29:
            _context2.prev = 29;

            if (!_didIteratorError) {
              _context2.next = 32;
              break;
            }

            throw _iteratorError;

          case 32:
            return _context2.finish(29);

          case 33:
            return _context2.finish(24);

          case 34:
            value = new Uint8Array(length);

            for (_i = 0, _parts = parts; _i < _parts.length; _i++) {
              _buf = _parts[_i];
              value.set(_buf, offset);
              offset += _buf.length;
            }

            debug("Received data for file '".concat(cid, "' size: ").concat(value.length, " in ").concat(parts.length, " blocks"));
            return _context2.abrupt("return", value);

          case 38:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 20, 24, 34], [25,, 29, 33]]);
  }));
  return _cat.apply(this, arguments);
}

exports = module.exports = HlsjsIPFSLoader;